import { icons } from 'assets/icons';
import useDevice from 'hooks/useDevice';
import { useState } from 'react';

import IconButton from 'components/Button/IconButton';
import { useUserListStore, useUserRolePermissionStore } from 'contexts/RootStore.context';
import { Horizontal, StretchSpacer } from 'gls';
import { isEmpty } from 'lodash';
import { colours } from 'styling/colours';
import { style } from 'typestyle';

import DownloadLogs from './DownloadLogs';
import { HeaderStyled, SearchStyleDiv } from './style';
import CategorySearchSelect from 'components/inputs/Select/CategorySearchSelect/CategorySearchSelect';
import { observer } from 'mobx-react';

export const HeaderSearch = observer(() => {
  const { isMobileDevice } = useDevice();
  const {
    searchTerm,
    usersList,
    setSearchTerm,
    setSearchCategory,
    searchCategoriesList,
    loadUsers
  } = useUserListStore();
  const [showSearch, setShowSearch] = useState(() => !isEmpty(searchTerm));
  const { canReportUsers } = useUserRolePermissionStore()

  const onSearch = (search: string, category: string) => {
    setSearchTerm(search)
    setSearchCategory(category)
    return loadUsers(true)
  }

  if (isMobileDevice) {
    return (
      <div className="container">
        {showSearch ? (
          <SearchStyleDiv>
            <div className="search-container">
              <CategorySearchSelect
                placeholder="Search for users"
                searchCategoriesList={searchCategoriesList}
                onSearch={onSearch}
              />
              {isEmpty(searchTerm) && (
                <IconButton
                  ariaLabel="Close Search"
                  className="close-search"
                  icon={<icons.CloseIcon aria-label='Close search' width="15px" height="15px" />}
                  onClick={() => setShowSearch(false)}
                />
              )}
            </div>
          </SearchStyleDiv>
        ) : (
          <HeaderStyled className="page-header">
            <div className="header-item title">
              <Horizontal width="100%">
                <StretchSpacer />
                <IconButton
                  ariaLabel="Open Search"
                  icon={<icons.SearchIcon aria-label='Open search' />}
                  onClick={() => setShowSearch(true)} />
              </Horizontal>
            </div>
          </HeaderStyled>
        )}
      </div>
    );
  }

  return (
    <div className="container">
      <Horizontal className={headerStyle} spacing="0">
        <CategorySearchSelect
          placeholder="Search for users"
          searchCategoriesList={searchCategoriesList}
          onSearch={onSearch}
        />
        <StretchSpacer />
        {canReportUsers && (<DownloadLogs disabled={false} />)}
      </Horizontal>
    </div >
  );
})

const headerStyle = style({
  width: '100%',
  padding: "10px",
  marginBottom: "10px",
  backgroundColor: colours.panelBackground,
  borderRadius: "6px",
})